import { Table } from 'components/table-compat/table-compat'
import { Container } from 'components/container/Container'
import { buildDataTableObject } from 'utils/data'
import {
    addHyperLinkToFirstColumn,
    getDynamicSubPath,
    setFirstColumnInHeaders,
} from './helpers'
import { useSafetyLeading } from 'hooks/safety/useSafetyLeading'
import { BasicPlaceholder } from 'components/placeholder'
import useRefresh from 'hooks/utils/useRefresh'
import useCountdown from 'hooks/utils/useCountdown'
import { ErrorAlert } from 'components/error-fallback/error-alert'
import { TRANSLATION_KEYS } from 'locales/translation-keys'
import { useEssentials } from 'hooks/utils/useEssentials'
import { translateTableData } from 'locales/utils'

export const SafetyLeading = () => {
    const { t, currentLocation, pathname, env, logout, session, isEnglish } =
        useEssentials()

    const dynamicSubPath = getDynamicSubPath(currentLocation)
    let { data, isLoading, isError, refetch, remove, error } = useSafetyLeading(
        {
            env,
            accessToken: session?.accessToken ?? '',
            location: currentLocation,
            dynamicSubPath,
        },
    )
    useRefresh(refetch, remove)
    const count = useCountdown(5, logout, error as Error)

    if (isLoading) {
        return (
            <div className="placeholder-container" data-testid="placeholder">
                <BasicPlaceholder type="table" rows={5} columns={5} />
            </div>
        )
    }
    if (isError || !data) {
        return (
            <ErrorAlert error={error} count={count} onRetry={() => refetch()} />
        )
    }

    data = {
        ...data,
        headings: setFirstColumnInHeaders(data, 'Location'),
    }
    data = addHyperLinkToFirstColumn(data, pathname)

    const { safety } = TRANSLATION_KEYS
    const { nonStoreLabel, leading } = safety
    const { title } = leading

    const translatedData = translateTableData({
        t,
        table: data,
        translation: leading,
    })

    return (
        <Container className="hc8-pa-4x">
            <p>{t(nonStoreLabel)}</p>
            <Table
                data={buildDataTableObject({
                    currentData: translatedData,
                    widths: isEnglish
                        ? [100, 100, 100, 100, 100, 100]
                        : [70, 100, 100, 70, 100, 110],
                    pinFirstColumn: true,
                })}
                name={t(title)}
                scrollableWidth={true}
            />
        </Container>
    )
}
